import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward'
import './ScrollToTop.css'

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const toggleVisibility = () =>
      window.pageYOffset > 500 ? setIsVisible(true) : setIsVisible(false)

    window.addEventListener('scroll', toggleVisibility)
    return () => window.removeEventListener('scroll', toggleVisibility)
  }, [])

  const location = useLocation()

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '')
      const scrollToId = () => {
        const el = document.getElementById(id)
        if (el) el.scrollIntoView({ behavior: 'smooth' })
        else {
          // retry shortly in case element isn't mounted yet
          setTimeout(() => {
            const el2 = document.getElementById(id)
            if (el2) el2.scrollIntoView({ behavior: 'smooth' })
          }, 100)
        }
      }

      // if we're not on home, React Router will navigate first; run scroll after a tick
      setTimeout(scrollToId, 0)
    }
  }, [location])

  return isVisible ? (
    <div className='scroll-top'>
      <a href='#top' aria-label='top'>
        <ArrowUpwardIcon fontSize='large' />
      </a>
    </div>
  ) : null
}

export default ScrollToTop
